import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Projects from "@/pages/Projects";
import BritanniaRow from "@/pages/BritanniaRow";
import BritanniaEvents from "@/pages/BritanniaEvents";
import Journal from "@/pages/Journal";
import JournalPost from "@/pages/JournalPost";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function PublicShell({ children }) {
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Toaster
            theme="dark"
            position="bottom-center"
            toastOptions={{
              style: {
                background: "#1c1919",
                color: "#f4efe9",
                border: "1px solid #3a3231",
                fontFamily: "'Libre Franklin', Calibri, sans-serif",
              },
            }}
          />
          <Routes>
            <Route path="/" element={<PublicShell><Home /></PublicShell>} />
            <Route path="/about" element={<PublicShell><About /></PublicShell>} />
            <Route path="/projects" element={<PublicShell><Projects /></PublicShell>} />
            <Route path="/projects/35-britannia-row" element={<PublicShell><BritanniaRow /></PublicShell>} />
            <Route path="/projects/35-britannia-row/events" element={<PublicShell><BritanniaEvents /></PublicShell>} />
            <Route path="/journal" element={<PublicShell><Journal /></PublicShell>} />
            <Route path="/journal/:slug" element={<PublicShell><JournalPost /></PublicShell>} />
            <Route path="/contact" element={<PublicShell><Contact /></PublicShell>} />
            <Route path="/admin/login" element={<PublicShell><AdminLogin /></PublicShell>} />
            <Route path="/admin" element={<PublicShell><AdminDashboard /></PublicShell>} />
            <Route
              path="*"
              element={
                <PublicShell>
                  <div className="hm-container py-32">
                    <p className="hm-eyebrow mb-6">404</p>
                    <h1 className="font-serif text-6xl">Page not found.</h1>
                  </div>
                </PublicShell>
              }
            />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
